/*
  SELECT FORM
*/
(function($){
  $.fn.selectForm = function(options) {

    var defaults = {
      keepOnChange : false,
      framework: 'ad'
    }

    var config               = $.extend({}, defaults, options),
        me                   = this,
        $select              = me.find('select'),
        dataRef              = $select.attr('name'),
        $option              = $select.children('option'),
        defaultText          = $select.data('prompt') || 'Choisir une option',
        optionsContentAsHtml = typeof $select.data('html') != 'undefined' ? $select.data('html') : true,
        defaultStyle         = '',
        $tmpInput            = $('<div></div>'),
        $tmpOptContainer     = $('<div></div>'),
        $container           = $select.parent();

    // Hide Select
    $select.hide();

    // Extract option and append them into $tmpOptContainer
    $option.each(function(){
      var $this       = $(this),
          thisVal     = $this.val(),
          thisText    = $this.text(),
          thisStyle   = $this.data('style'),
          liConfig    = {
            style: (thisStyle || ''),
            'data-value': thisVal,
          };

      liConfig[optionsContentAsHtml ? 'html' : 'text'] = $this.data('html') || thisText;

      var $newLi = $('<li/>', liConfig);

      if($this.attr('selected')) {
        defaultText = $this.text();
        defaultStyle = $this.data('style');
        if(config.keepOnChange) {
          $newLi.addClass('selected');
        }
      }

      if(thisText != "") $newLi.appendTo($tmpOptContainer);
    });

    // Input
    $tmpInput.addClass('sb-'+ config.framework +'-form-input select sb-'+ config.framework +'-select-close')
             .data('ref', dataRef)
             .appendTo($container);

    $arrow   = $('<i class="fa fa-chevron-down"></i>');
    $arrow.appendTo($tmpInput);
    $spanVal = $('<span class="sb-'+ config.framework +'-select-val" style="' + defaultStyle + '"></span>');
    if(optionsContentAsHtml) {
      $spanVal.html(defaultText);
    } else {
      $spanVal.text(defaultText);
    }
    $spanVal.appendTo($tmpInput);

    // OptionContainer
    $tmpOptContainer.addClass('sb-'+ config.framework +'-result-autocompletion sb-'+ config.framework +'-result-autocompletion-styled hidden')
                    .data('ref', dataRef);


    // Click event
    $tmpInput.on('click', function(e) {
      e.stopPropagation();
      var $this = $(this),
          cls   = $this[0].className.match(/(sb-(ad|vi)-select-open|sb-(ad|vi)-select-close)/)[0];

      switch(cls){
        case 'sb-'+ config.framework +'-select-close' :
          displayOption('show');
          break;

        case 'sb-'+ config.framework +'-select-open':
          displayOption('hide');
          break;
      }
      placeOption($tmpInput);
    });

    $tmpOptContainer.on('click', 'li', function()
    {
      var $this           = $(this),
          thisVal         = $this.data('value');
          thisText        = optionsContentAsHtml ? ($this.find('.label').text() || $this.text()) : $this.text();
          thisStyle       = $this.attr('style');
          $optionToSelect = returnOption(thisVal);

      $option.removeProp('selected');
      $optionToSelect.prop('selected', 'selected');
      $select.trigger('change');
      $tmpInput.find('span.sb-'+ config.framework +'-select-val').text(thisText).attr('style', thisStyle);

      if(!config.keepOnChange) {
        displayOption('hide');
      } else {
        $tmpOptContainer.find('li').removeClass('selected');
        $this.addClass('selected');
      }
    });

    if(!config.keepOnChange) {
      $(document).on('click', function(e) {
        if($tmpOptContainer.is(':visible') && $tmpInput.hasClass('sb-'+ config.framework +'-select-open')) {
          $tmpInput.trigger('click');
        }
      });
    }

    function returnOption(val){
      var $obj;
      $option.each(function(){
        if ($(this).val() == val) {
          $obj = $(this);
        }
      });

      return $obj;
    }

    // Hide/Show Option
    function displayOption(state){
      switch(state){
        case 'show':
          $tmpInput.addClass('sb-'+ config.framework +'-select-open').removeClass('sb-'+ config.framework +'-select-close');
          $tmpOptContainer.removeClass('hidden');
          break;

        case 'hide':
          $tmpInput.removeClass('sb-'+ config.framework +'-select-open').addClass('sb-'+ config.framework +'-select-close');
          $tmpOptContainer.addClass('hidden');
          break;
      }
    }

    // PlaceOption
    function placeOption(input) {
      var inputH = input[0].offsetHeight;

      $container.css('position', 'relative');

      $tmpOptContainer.appendTo($container).css({
        bottom   : 'inherit',
        top      : (inputH - 1) + 'px',
        left     : '0px',
        width    : '100%',
        position : 'absolute',
      });
    }

    $(window).on('resize', function(){
      placeOption($tmpInput);
    });

    $select.on('change', function() {
      var $selectedLi = $tmpOptContainer.find("li[data-value='"+$(this).val()+"']");
      var $inputVal = $tmpInput.find('span.sb-'+ config.framework +'-select-val');

      if($selectedLi.text() != $inputVal.text()) {
        $tmpInput.find('span.sb-'+ config.framework +'-select-val').text("Choisir une option");
      }

      $select.find('option[data-toggle-target]').each(function() {
        var $option = $(this),
            $toggleTarget = $($option.data('toggle-target'));

        if($select.val() == $option.val()) {
          $toggleTarget.show();
        } else {
          $toggleTarget.hide();
        }
      });
    });

    return this;
  };
})(jQuery);

/*
  sb-ad-CHECKBOX
*/
(function($) {
  var defaults = {
    framework : 'ad'
  }

  $.fn.sbCheckbox = function(options) {
    var config = $.extend({}, defaults, options);

    this.on('change', '.sb-' + config.framework + '-form-group-checkbox input', function(){
      var $thisLabel = $(this).parent();
      if($(this).is(':checked')){
        $thisLabel.addClass('checked');
      } else {
        $thisLabel.removeClass('checked');
      }
    });

    var $checkbox = this.find('.sb-' + config.framework + '-form-group-checkbox input');
    $checkbox.each(function(){
      var $this = $(this);
      if($this.is(':checked')) {
        $this.parent().addClass('checked');
      }
    });

    return this;
  }

})(jQuery);

/*
  sb-ad-RADIO
*/
(function($) {
  var defaults = {
    framework : 'ad'
  }

  $.fn.sbRadio = function(options) {
    var config = $.extend({}, defaults, options);

    var $radios = this.find('input[type=radio]');
    $radios.each(function() {
      var $this = $(this),
          $label = $this.closest('.sb-ad-input-radio'),
          $checkedDisplayElement = $($this.data('checked-display-element'));

      if($this.is(':checked')) {
        $checkedDisplayElement.show();
      } else {
        $checkedDisplayElement.hide();
      }

      if($this.is(':disabled')) {
        $label.attr('disabled', true);
      }
    });

    $radios.filter(':checked').parents('.sb-ad-input-radio').addClass('active');

    this.on('change', 'input[type=radio]', function() {
      var $this  = $(this),
          $label = $this.parents('.sb-' + config.framework + '-input-radio'),
          $checkedDisplayElement = $($this.data('checked-display-element')),
          name   = $this.attr('name'),
          targetInputText = $label.data('target-input-text');

      if($(targetInputText).length) {
        $(targetInputText).val($.trim($label.text()));
      }

      $('input[type=radio][name="'+name+'"]').parents('.sb-' + config.framework + '-input-radio').removeClass('active');

      $this.closest('.sb-' + config.framework + '-input-radio').siblings().find('input[type=radio]').each(function(){
        var $t = $(this),
            $a = $($t.data('checked-display-element'));
            if($a.length) $a.hide();
      });

      $label.addClass('active');
      if($checkedDisplayElement.length) $checkedDisplayElement.fadeIn('fast');
    });

    return this;
  }
})(jQuery);

/*
  SUBMIT ON CHANGE
*/
(function($){
  $("body").on("change", ".submit-on-change", function() {
    var $this = $(this),
        $form = $this.closest('form');
    if($form.length > 0) { $form.submit(); }
  });
})(jQuery);
